import {props} from '@ngrx/store';
import {createActionWithCorrelation} from '@kion/ngrx-helper';
import {CmsPage} from '@kion/data-models';

export const loadAllSuccess = createActionWithCorrelation(
  "[CmsPage] loadAll Success",
  props<{ cmsPages: CmsPage[] }>()
);
export const loadAllError = createActionWithCorrelation(
  "[CmsPage] loadAll Error",
  props<{error: any}>()
);
export const loadAll = createActionWithCorrelation(
  "[CmsPage] loadAll",
  loadAllSuccess.type,
  loadAllError.type
);

export const loadCmsPageSuccess = createActionWithCorrelation(
  "[CmsPage] load cmsPage success",
  props<{ cmsPage: CmsPage }>()
);
export const loadCmsPageError = createActionWithCorrelation(
  "[CmsPage] load cmsPage error",
  props<{ error: any }>()
);
export const loadCmsPage = createActionWithCorrelation(
  "[CmsPage] load cmsPage",
  props<{ cmsPageId?: string, isTicket: boolean, cmsTicketId?: string, }>(),
  loadCmsPageSuccess.type,
  loadCmsPageError.type
);

export const loadProductCmsPageSuccess = createActionWithCorrelation(
  "[CmsPage] load product cms page success",
  props<{ cmsPage: CmsPage }>()
);
export const loadProductCmsPageError = createActionWithCorrelation(
  "[CmsPage] load product cms page error",
  props<{ error: any }>()
);
export const loadProductCmsPage = createActionWithCorrelation(
  "[CmsPage] load product cms page",
  props<{ code: string }>(),
  loadProductCmsPageSuccess.type,
  loadProductCmsPageError.type
);

export const loadNetworkPartnerTermsAndConditionsContentSuccess = createActionWithCorrelation(
  "[CmsPage] load NetworkPartnerTermsAndConditions markdown content success",
  props<{ nwpId: string, termsAndConditions: string }>()
);
export const loadNetworkPartnerTermsAndConditionsContentError = createActionWithCorrelation(
  "[CmsPage] load NetworkPartnerTermsAndConditions markdown content error",
  props<{ error: any }>()
);
export const loadNetworkPartnerTermsAndConditionsContent = createActionWithCorrelation(
  "[CmsPage] load NetworkPartnerTermsAndConditions markdown content",
  props<{ nwpId: string }>(),
  loadNetworkPartnerTermsAndConditionsContentSuccess.type,
  loadNetworkPartnerTermsAndConditionsContentError.type
);

export const loadNetworkPartnerPrivacyPolicyContentSuccess = createActionWithCorrelation(
  "[CmsPage] load NetworkPartnerPrivacyPolicy markdown content success",
  props<{ nwpId: string, privacyPolicy: string }>()
);
export const loadNetworkPartnerPrivacyPolicyContentError = createActionWithCorrelation(
  "[CmsPage] load NetworkPartnerPrivacyPolicy markdown content error",
  props<{ error: any }>()
);
export const loadNetworkPartnerPrivacyPolicyContent = createActionWithCorrelation(
  "[CmsPage] load NetworkPartnerPrivacyPolicy markdown content",
  props<{ nwpId: string }>(),
  loadNetworkPartnerPrivacyPolicyContentSuccess.type,
  loadNetworkPartnerPrivacyPolicyContentError.type
);
